import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d173e8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { key: 0 }

import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-overview-3',
  setup(__props) {

const showData = computed(() => {
  return getOverviewData(_testOverviewData, false, false, false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item-block",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "icon",
            innerHTML: item.icon
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (item.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.name) + "：", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(item.value), 1)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})